import {
    CONFIRMED_GET_NOTE_CATEGORIES,
    CONFIRMED_CREATE_NOTE_CATEGORIES,
    CONFIRMED_DELETE_NOTE_CATEGORIES,
    CONFIRMED_EDIT_NOTE_CATEGORIES,
  } from "../types/NoteCategoriesType";
  
  import {
    getNoteCategories,
    addNoteCategory,
    updateNoteCategory,
    deleteNoteCategory,
    formatNoteCategories,
  } from "../../services/NoteCategoriesService";
  
  import { handleError, handleSuccess, showErrorAlert } from "../../services/ErrorHandlingService";
  
  // Get list
  export function getNoteCategoriesAction(
    pagination = true,
    pageid = 0,
    search_by = "",
    search_keyword = "",
    sort_by = "",
    sort_order = ""
  ) {
    return async (dispatch) => {
      try {
        const response = await getNoteCategories(
          pagination,
          pageid,
          search_by,
          search_keyword,
          sort_by,
          sort_order
        );
  
        if (response?.status === 200 && response.data?.status === "success") {
          const list = formatNoteCategories(response.data.data);
          const num_rows = response.data.num_rows || 0;
  
          dispatch({
            type: CONFIRMED_GET_NOTE_CATEGORIES,
            payload: { list, num_rows },
          });
        } else {
          handleError("Failed to get Note Categories");
        }
      } catch (error) {
        console.error(error);
        showErrorAlert("Failed to get Note Categories");
      }
    };
  }
  
  // Delete
  export function deleteNoteCategoryAction(noteCategoryId) {
    return async (dispatch) => {
      try {
        await deleteNoteCategory(noteCategoryId);
        dispatch({
          type: CONFIRMED_DELETE_NOTE_CATEGORIES,
          payload: { category_id: noteCategoryId },
        });
        handleSuccess("Note Category deleted successfully!");
      } catch (error) {
        console.error(error);
        showErrorAlert("Failed to delete Note Category");
      }
    };
  }
  
  // Create
  export function addNoteCategoryAction(noteCategoryData, navigate) {
    return async (dispatch) => {
      try {
        const response = await addNoteCategory(noteCategoryData);
  
        if (response?.status === 200 && response.data?.status === "success") {
          const formatted = formatNoteCategories([response.data.data])[0];
          dispatch({
            type: CONFIRMED_CREATE_NOTE_CATEGORIES,
            payload: formatted,
          });
          if (navigate) navigate("/noteCategories");
          handleSuccess("Note Category created successfully!");
        } else {
          showErrorAlert("Failed to create Note Category");
          throw new Error(response?.data?.messages?.error || "Failed to create Note Category");
        }
      } catch (error) {
        console.error(error);
        showErrorAlert(error.message || "Failed to create Note Category");
        throw error;
      }
    };
  }
  
  // Update
  export function updateNoteCategoryAction(noteCategoryData, noteCategoryId, navigate) {
    return async (dispatch) => {
      try {
        const payload = {
          ...noteCategoryData,
          category_id: noteCategoryId,
        };
  
        const response = await updateNoteCategory(payload);
  
        if (response?.status === 200 && response.data?.status === "success") {
          const formatted = formatNoteCategories([response.data.data])[0];
          dispatch({
            type: CONFIRMED_EDIT_NOTE_CATEGORIES,
            payload: formatted,
          });
          if (navigate) navigate("/noteCategories");
          handleSuccess("Note Category updated successfully!");
        } else {
          showErrorAlert("Failed to update Note Category");
          throw new Error(response?.data?.messages?.error || "Failed to update Note Category");
        }
      } catch (error) {
        console.error(error);
        showErrorAlert(error.message || "Failed to update Note Category");
        throw error;
      }
    };
  }
  